<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card title="Aquí puedes generar y revisar las Referencias bancarias de tu preferencia." code-toggler>
<div>
<b>
Nota Importante: <br>    </b>
Una vez realizado el pago, se tardará hasta 24 horas hábiles(L - V) en verse reflejado en la columna Estatus. <br>
<!-- Las Referencias pagadas en Farmacias ISSEG, el Estatus se verá reflejado en automatico -->
          
</div>

    <div class="">
      <vs-popup style="" class="holamundo"  title="Nueva referencia bancaria" :active.sync="popupActive">

        <div class="vx-col w-full ">

          <div class="">

            <p>Elija los datos de su pago a continuación:</p>
          </div>
          <div class="demo-alignment">
           <p>Area:
            <v-select style="width: 350px;"  label="area" @change="get_conceptos()" v-model="area_select" :options="areas_pagos"></v-select></p>
            <p>Concepto:
            <v-select style="width: 350px;"  label="arancel" v-model="concepto_select" :options="conceptos_pagos"></v-select></p>

            <div v-show="this.concepto_select.id == 17">
              <p>Talla:
              <v-select style="width: 350px;"  label="talla" v-model="talla_selected" :options="cat_tallas"></v-select></p>
            </div>

              <div v-show="this.concepto_select.id == 1">
                <p class="alert alert-danger" role="alert">
                 Este módulo solo es para pagar adeudos de cuatrimestres anteriores,<br> para el proceso de Re-inscripción a un nuevo cuatrimestre
                 <a href="/alumnos/inscripcion/" target="" rel="noopener noreferrer"> da clic aquí!</a>
                  </p>
             </div>
<!-- <br> -->
            <p>Cuatrimestre:
            <v-select style="width: 350px;"  label="cuatrimestre" v-model="cuatrimestre_select" :options="cuatrimestres_pagos"></v-select></p>
          </div>
        </div>

        <div >
            <p style="margin: 10px;">
              <vs-button :disabled="this.concepto_select.id == 1 && this.bloqueado_temp == 1" class="float-right" @click="guardar_nuevo_pago()" >Generar referencia</vs-button>
            </p>
        </div>
        


      </vs-popup>

    </div>

    <div class="mt-5">
      <vs-tabs>


        <!-- tab 2 content -->
        <vs-tab label="" class="mb-12">
          <div style="text-align: right;">
            <p>
              <vs-button class="" style="margin: 3px;"  @click="nuevo_pago()">Nueva referencia bancaria</vs-button>

            </p>
          </div>
          <div class="flex-centered">

            <vs-table stripe :data="referencias">

              <template slot="thead">
                <vs-th>CIE BBVA</vs-th>
                <vs-th>Referencia BBVA</vs-th>
                  <vs-th>Referencia ISSEG</vs-th>
                <vs-th>Cantidad</vs-th>
                <vs-th>Area</vs-th>
                <vs-th>Concepto</vs-th>
                <vs-th>Cuatrimestre</vs-th>

                <vs-th>Caducidad</vs-th>

                <vs-th>Estatus</vs-th>
                <vs-th></vs-th>

              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].id">
                      {{data[indextr].cie}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].referencia}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].referenciaIsseg}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].costo}}
                  </vs-td>

                  <vs-td :data="data[indextr].id">

                    {{data[indextr].area}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].concepto}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].idCuatrimestre}}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{data[indextr].fechaCaducidad}}
                  </vs-td>

                  <vs-td v-if="data[indextr].pagado == 1" :data="data[indextr].id">
Pagado
                  </vs-td>
                  <vs-td v-else :data="data[indextr].id">
                    {{data[indextr].pagado}}
Pendiente de pago
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    <vs-button color="danger" @click="ver_pdf(data[indextr].idf)" class="" >PDF</vs-button>
                  </vs-td>

                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>



        <!-- tab 3
        <vs-tab label="Generar Actas" class="mb-5">
            <p>Trabajando...</p>
        </vs-tab>
        content -->
      </vs-tabs>
    </div>
  </vx-card>

</template>

<script>
import vSelect from 'vue-select'
// import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'


import Table from "../ui-elements/table/Table";

// import DragItDude from "vue-drag-it-dude";
import Button from "../components/vuesax/button/Button";

export default {
  data() {
    return {
      popupActive: false,

      area_select: [
//<<<<<<< HEAD
          { area: "Seleccione un area", id:1  }
//=======
         // {area: "Seleccionar area", id :1}
//>>>>>>> fa268ce3d1d38172c0b81726506277ac9d58fe26
      ],
      concepto_select: [],
      cuatrimestre_select: [],

      areas_pagos:[],
      conceptos_pagos:[],
      cuatrimestres_pagos:[],
      referencias:[],
      bloqueado_temp:[],
      cat_tallas:[],
      talla_selected:{},

      carrera: localStorage.getItem('id_carrera'),

      id: localStorage.getItem('id'),
      options1: [
        {text: 'Servicios escolares', value: 1},
      ],
      options2: [
        {text: 'Inscripción a licenciatura cuatrimestral', value: 1},
        {text: 'Examen extraordinario por materia', value: 2},
      ],
      options3: [
        {text: 'Primero', value: 1},
        {text: 'Segundo', value: 2},
      ],
      options4: [
        {text: 'Administración estratégica', value: 0},
        {text: 'Administración del mantenimiento', value: 0},
      ],

    }
  },
  components: {
    Button,
    Table,
    'v-select': vSelect,
  },
  created() {

   //
    this.id = localStorage.getItem('id');
    

  },
  mounted() {
   // this.$vs.loading();
   this.get_tallas();
    this.get_areas();
    this.get_conceptos();
    this.get_cuatrimestres();
    this.getReferencias();
    this.get_conceptos_pago_re_inscripcion_bloqueado_temp();
  },
  watch: {

  },
  methods: {
nuevo_pago(){
  this.popupActive=true;
  this.area_select={};
  this.concepto_select={};
   this.cuatrimestre_select={};
    this.talla_selected={};

},
    ver_pdf(id){

  //console.log(id)
      open('http://cdn.upbicentenario.edu.mx/api/pdf_referencia_bancomer/' + id) //para que se pueda descargar en telefonos celulares se le quita el weindows. y solo se usa open
      //window.open('http://127.0.0.1:8000/api/pdf_referencia_bancomer/' + id)  

    
    },

    get_areas() {

      this.$http.get("areas_pagos").then(
          response => {
            // console.log(response.data)
            this.areas_pagos = response.data.areas_pagos;
            this.$vs.loading.close();
            //console.log(this.kardex);
          },
          error => {
            this.StepError(error);
          }
      );

    //  alert("a");
     // this.$vs.loading.close();
    },
    get_conceptos() {

      this.$http.get("conceptos_pagos/" + this.area_select.id).then(
          response => {
            // console.log(response.data)
            this.conceptos_pagos = response.data.conceptos_pagos;
            // this.area_select='';
            this.$vs.loading.close();
            //console.log(this.kardex);
          },
          error => {
            this.StepError(error);
          }
      );

    },


 get_conceptos_pago_re_inscripcion_bloqueado_temp() {

      this.$http.get("conceptos_pago_re_inscripcion_bloqueado_temp").then(
          response => {
            this.bloqueado_temp = response.data.conceptos_pago_re_inscripcion_bloqueado_temp;
            this.$vs.loading.close();
          },
          error => {
            this.StepError(error);
          }
      );

    },

    get_tallas() {

      this.$http.get("get_tallas").then(
          response => {
            // console.log(response.data)
            this.cat_tallas = response.data.tallas;
            this.$vs.loading.close();
          },
          error => {
            this.StepError(error);
          }
      );
    },
    get_cuatrimestres() {

      this.$http.get("cuatrimestres_pagos").then(
          response => {
            // console.log(response.data)
            this.cuatrimestres_pagos = response.data.cuatrimestres_pagos;
            this.$vs.loading.close();
            //console.log(this.kardex);
          },
          error => {
            this.StepError(error);
          }
      );

      //  alert("a");
      // this.$vs.loading.close();
    },

    getReferencias() {
      this.$http.get("get_referencias_bancomer/" + this.id).then(
          response => {
            // console.log(referencias.data)
            this.referencias = response.data.referencias;
            //console.log(this.kardex);
          },
          error => {
            this.StepError(error);
          }
      );
    },
    guardar_nuevo_pago(){
      this.popupActive=false
      this.$http.get("guardar_referencia_bancomer/" + this.id + "/" + this.area_select.id + "/" + this.concepto_select.id + "/" + this.cuatrimestre_select.id+"/"+this.talla_selected.id).then(
          response => {
            
            this.getReferencias();
          },
          error => {
            this.StepError(error);
          }
      );
    },

  }
}
</script>
